import { getTimeZoneOptions } from "../shared/utils/timezoneUtils";

export interface BillingTimeZoneOption {
  timezone: string;
  offset: string;
  label: string;
  search: string;
}

const aliases: Record<string, string> = {
  "America/Los_Angeles": "California Pacific Time PST PDT",
  "Asia/Calcutta": "India Kolkata IST",
  "Asia/Kolkata": "India Calcutta IST",
};

export function billingTimeZoneOption(timezone: string, date = new Date()): BillingTimeZoneOption {
  const name = new Intl.DateTimeFormat("en-US", { timeZone: timezone, timeZoneName: "longOffset" })
    .formatToParts(date).find(part => part.type === "timeZoneName")!.value;
  const offset = name === "GMT" ? "UTC+00:00" : name.replace("GMT", "UTC");
  const label = `${timezone.split("/").pop()!.replace(/_/g, " ")} (${offset})`;
  const compact = offset.replace(":", "");
  return { timezone, offset, label, search: `${timezone} ${label} ${compact} ${compact.replace(/([+-])0/, "$1")} ${aliases[timezone] || ""}` };
}

export function billingTimeZoneOptions(extraTimeZone?: string | null) {
  const date = new Date();
  return getTimeZoneOptions(extraTimeZone).map(timezone => billingTimeZoneOption(timezone, date));
}
